import { SimpleDateSelectType } from 'src/admin-entity/enum/search/simple-date-select-type.enum';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { PointHistory } from 'src/admin-entity/interface/point/point-history.interface';
import { PointInfo } from 'src/admin-entity/interface/point/point-info.interface';
import { UserPointSpending } from 'src/admin-entity/interface/point/user-point-spending.interface';

export interface PointInitType {
    searchCondition: {
        grade: number;
        searchToken: string;
        searchTopic: string;
        memo: string;
        adminUserName: string;
        beginDate: string;
        endDate: string;
        selectedStartDateType: SimpleDateSelectType;
        page: number;
        take: number;
        userGradeList: number[];
        searchType: string;
    };
    rewardHistorySearchCondition: {
        memo: string;
        user: string;
        beginDate: string;
        endDate: string;
        selectedStartDateType: SimpleDateSelectType;
        page: number;
        take: number;
        adminUserName: string;
    };
    pointList: Page<UserPointSpending>;
    pointListWithExcel: Page<PointHistory>;
}

export const initialState: PointInitType = {
    searchCondition: {
        grade: 0,
        searchToken: '',
        searchTopic: 'appUserId',
        memo: '',
        adminUserName: '',
        beginDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toString(),
        endDate: Date(),
        selectedStartDateType: 'today',
        page: 0,
        take: 30,
        userGradeList: [],
        searchType: '',
    },
    rewardHistorySearchCondition: {
        memo: '',
        user: '',
        beginDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toString(),
        endDate: Date(),
        selectedStartDateType: 'today',
        page: 0,
        take: 30,
        adminUserName: '',
    },
    pointList: {
        page: {
            count: 0,
        },
        list: [],
    },
    pointListWithExcel: {
        page: {
            count: 0,
        },
        list: [],
    },
};
